/**
 * Hide-referrer input: None / Blank / Domain / No-referrer.
 * When 'DOMAIN' is picked, a second input collects the referrer domain to send.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { SearchableSelect } from '@/components/ui/form/input/SearchableSelect';
import { Input } from '@/components/ui/form/input/Input';

const OPTIONS = [
  { value: 'NONE', label: 'None' },
  { value: 'BLANK', label: 'Blank' },
  { value: 'DOMAIN', label: 'Domain' },
  { value: 'NO_REFERRER', label: 'No referrer' },
] as const;

export interface BinomHideReferrerInputProps {
  type: string | undefined;
  domain: string | undefined;
  onChange: (
    patch: Partial<{ hideReferrerType: string; hideReferrerDomain: string }>,
  ) => void;
}

const BinomHideReferrerInput: FC<BinomHideReferrerInputProps> = ({
  type,
  domain,
  onChange,
}) => (
  <div className="flex flex-col gap-1.5">
    <SearchableSelect
      value={type ?? 'NONE'}
      onChange={(v) => onChange({ hideReferrerType: v })}
      options={OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
      placeholder="None"
    />
    {type === 'DOMAIN' && (
      <Input
        value={domain ?? ''}
        onChange={(e) => onChange({ hideReferrerDomain: e.target.value })}
        className="h-7 text-xs"
        placeholder="example.com"
        aria-label="Hide referrer domain"
      />
    )}
  </div>
);

export default BinomHideReferrerInput;
